import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var PayoutNotReceivedIA = function PayoutNotReceivedIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Vlx7bU",
    defaultMessage: [{
      "type": 0,
      "value": "Si votre paiement tarde à vous parvenir, vous pouvez déterminer la raison du retard en vérifiant quelques détails clés sur votre commande et dans les paramètres de votre compte. Voici ce que vous devez vérifier :"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "L8yZ/q",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Statut de la commande :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " pour que le paiement soit émis en votre faveur, votre commande doit avoir le statut « Expédiée ». Saisissez bien les informations de suivi de l'expédition afin que le statut de la commande soit exact."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "bNsRBC",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Options de paiement :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " vérifiez les "
    }, {
      "children": [{
        "type": 0,
        "value": "conditions de paiement"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " que vous avez sélectionnées. Le paiement sera émis au maximum 60 jours après l'expédition, selon les conditions que vous avez choisies. Votre compte est généralement crédité dans les 3 à 5 jours ouvrés après l'émission du paiement, en fonction du délai de traitement de votre banque."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "KumpfT",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Coordonnées bancaires :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " vérifiez que vos coordonnées bancaires sont exactes et à jour. Des informations incorrectes peuvent entraîner des retards dans les paiements."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "hLc85/",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Précommandes :"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " pour les précommandes, les dates de paiement et d'expédition peuvent conserver le statut « inconnues » jusqu'à ce que l'exécution de la précommande soit terminée. Attendez que ces commandes aient été traitées pour recevoir votre paiement."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};